import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBrightness: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBrightness"><Circle cx="12" cy="12" r="5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M12 1.75V2.775M12 21.225V22.25M4.75218 4.75216L5.47696 5.47694M18.5231 18.5231L19.2479 19.2478M19.2479 4.75218L18.5231 5.47696M5.47699 18.5231L4.7522 19.2479M1.75 12H2.775M21.225 12H22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBrightness;
